<template>
  <widget-content
    :config="config"
    variant="health"
    :css-class="`${bgCssClass} ${textCssClass}`"
  >
    <div slot="widget-header">
      <!-- -->
    </div>
    <div
      v-if="icon"
      class="text-center h2 health-icon mb-4"
    >
      <i :class="`fa fa-fw ${icon}`"></i>
    </div>
    <div
      v-if="displayTitle"
      :class="`${textCssClass} text-center small text-uppercase mb-4`"
      v-html="displayTitle"
    ></div>
    <div
      v-if="headline"
      :class="`${textCssClass} h5 text-center mb-3`"
      v-html="headline"
    ></div>
    <div
      v-if="description"
      :class="`${textCssClass} h6 text-center font-weight-normal`"
      v-html="description"
    ></div>
    <div class="widget-footer" slot="widget-footer">
      <hr>
      <widget-header
        :margin-bottom="false"
        :explore-btn-class="`${btnCssClass} ${textCssClass}`"
        hide-icon
        hide-title
      ></widget-header>
    </div>
  </widget-content>
</template>

<style lang="scss" scoped>
.widget-health {
  .health-icon {
    color: rgba(0, 0, 0, 0.20);
  }
}
</style>

<script>
import WidgetContent from './components/WidgetContent'
import WidgetHeader from './components/WidgetHeader'
import { get } from 'lodash'

export default {
  components: {
    WidgetContent,
    WidgetHeader
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    textCssClass () {
      return this.status ? 'text-white' : 'text-body'
      // return 'text-white'
    },
    bgCssClass () {
      return this.status ? `bg-${this.status}` : 'bg-white'
      // return this.status ? `bg-${this.status}` : 'bg-flat-peter-river'
    },
    btnCssClass () {
      return this.status ? `btn-${this.status} active` : 'btn-white'
      // return this.status ? `btn-${this.status} active` : 'btn-flat-peter-river active'
    },
    displayTitle () {
      return this.title !== null && this.title !== undefined ?
        this.title
        : this.config.title
    },
    headline () {
      return get(this.config, 'headline')
    },
    description () {
      return get(this.config, 'description')
    },
    status () {
      return get(this.config, 'status')
    },
    icon () {
      return get(this.config, 'icon')
    }
  }
}
</script>